import RecentOrders from "@/views/public/order/RecentOrders.vue";

export default {
  path: "/recent",
  name: "recent",
  component: RecentOrders
};
